/* BD FREE CHROME WEEKEND v1.3 - logic. One free base per order. Config: window.BD_FREE_CHROME (snippets/bd-free-chrome.liquid) */
(function () {
  'use strict';
  if (window.__bdFreeChromeV1) return;
  window.__bdFreeChromeV1 = true;

  var C = window.BD_FREE_CHROME;
  if (!C) return;
  var doc = document;
  var K_PREVIEW = 'bdFcPreview', K_CHOICE = 'bdFcChoice', K_PROMPTED = 'bdFcPrompted';
  var KIT_RE = /graphics[\s-]*kit|decal[\s-]*kit/i;
  var EXCL_RE = /reprint|replacement|upgrade|heal your bike/i;
  var BASE_RE = /premium\s*base/i;
  var CHECK = '<svg viewBox="0 0 12 12" fill="none"><path d="M2 6.2 4.8 9 10 3.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  (function () {
    var m = /[?&]bd_chrome_preview=([01])/.exec(location.search);
    if (m) ss(K_PREVIEW, m[1]);
  })();

  function isActive() {
    var p = ss(K_PREVIEW);
    if (p === '1') return true;
    if (p === '0') return false;
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') return true; } catch (e) {}
    var n = Date.now();
    return n >= C.start && n <= C.end;
  }

  /* ---------- money ---------- */
  function rate() { try { return parseFloat(Shopify.currency.rate) || 1; } catch (e) { return 1; } }
  function curOf(cart) {
    var c = (cart && cart.currency) || '';
    if (!c) { try { c = Shopify.currency.active; } catch (e) {} }
    return String(c || 'EUR').toUpperCase();
  }
  function money(cents, cur) {
    var a = Math.max(0, cents) / 100, whole = Math.abs(a - Math.round(a)) < 0.005;
    var s = whole ? String(Math.round(a)) : a.toFixed(2).replace('.', ',');
    if (cur === 'EUR') return '\u20ac' + s;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(a);
    } catch (e) { return s + ' ' + cur; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* ---------- cart analysis ---------- */
  function prop(it, re) {
    var p = it.properties || {};
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k) && re.test(k) && p[k] != null && p[k] !== '') return String(p[k]);
    return '';
  }
  function isKit(it) {
    if (it.variant_id == C.chrome.id || it.variant_id == C.holo.id) return false;
    var t = (it.product_title || '') + ' ' + (it.handle || '');
    if (EXCL_RE.test(t)) return false;
    if (prop(it, BASE_RE)) return true;
    return KIT_RE.test(t) && (it.final_line_price || it.line_price || 0) > 0;
  }
  function analyze(cart) {
    var a = { kits: 0, chrome: null, holo: null, paid: '', count: cart.item_count || 0, value: cart.total_price || 0, cur: curOf(cart) };
    (cart.items || []).forEach(function (it) {
      if (!it || it.quantity <= 0) return;
      if (it.variant_id == C.chrome.id) { a.chrome = it; return; }
      if (it.variant_id == C.holo.id) { a.holo = it; return; }
      if (isKit(it)) {
        a.kits += it.quantity;
        var b = prop(it, BASE_RE);
        if (/chrome|holo/i.test(b)) a.paid = b.replace(/\(.*$/, '').trim();
      }
    });
    a.active = isActive();
    a.target = Math.round(C.threshold * rate() * 100);
    a.unlocked = a.value >= a.target;
    a.toGo = Math.ceil(Math.max(0, a.target - a.value) / 100) * 100;
    a.pct = a.target > 0 ? Math.min(100, Math.round(a.value / a.target * 100)) : 100;
    a.eligible = a.active && a.unlocked && a.kits > 0;
    a.choice = a.chrome ? 'chrome' : a.holo ? 'holo' : (ss(K_CHOICE) === 'regular' ? 'regular' : '');
    return a;
  }

  /* ---------- cart writes ---------- */
  var busy = false, lastCart = null, A = null, syncCount = 0, syncWin = 0, gotEvent = false;
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (j) { throw j; }, function () { throw {}; });
    });
  }
  function refresh() {
    if (window.BDCart && typeof BDCart.refresh === 'function') { BDCart.refresh(); return; }
    fetch('/cart.js?ymq-no-listen=true&t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(handle).catch(function () {});
  }

  /* Keep the free lines matching the rules (runs on every cart change). */
  function sync(a) {
    if (busy) return;
    var up = {}, n = 0;
    function set(line, q) { if (line && line.quantity !== q) { up[line.key] = q; n++; } }
    if (!a.eligible) { set(a.chrome, 0); set(a.holo, 0); }
    else if (a.chrome && a.holo) {
      var keepHolo = ss(K_CHOICE) === 'holo';
      set(keepHolo ? a.chrome : a.holo, 0);
      set(keepHolo ? a.holo : a.chrome, 1);
    } else { set(a.chrome, 1); set(a.holo, 1); }
    if (!n) return;
    if (Date.now() - syncWin > 15000) { syncWin = Date.now(); syncCount = 0; }
    if (++syncCount > 4) return;
    busy = true;
    post('/cart/update.js?bd-marker=1', { updates: up }).then(fin, fin);
    function fin() { busy = false; refresh(); }
  }

  function choose(kind) {
    var a = A;
    if (!a || !a.eligible || busy) return;
    ss(K_CHOICE, kind);
    var up = {}, has = false;
    if (a.chrome && kind !== 'chrome') { up[a.chrome.key] = 0; has = true; }
    if (a.holo && kind !== 'holo') { up[a.holo.key] = 0; has = true; }
    var need = (kind === 'chrome' && !a.chrome) ? C.chrome : (kind === 'holo' && !a.holo) ? C.holo : null;
    if (!has && !need) { handle(lastCart); return; }
    busy = true; setBusy(true);
    var p = has ? post('/cart/update.js?bd-marker=1', { updates: up }) : Promise.resolve();
    if (need) {
      p = p.then(function () {
        return post('/cart/add.js?bd-marker=1', { items: [{ id: need.id, quantity: 1, properties: { 'Deal': C.dealLabel, '_bd_free_chrome': '1' } }] });
      });
    }
    p.then(fin, function (e) {
      fin();
      try { alert((e && (e.description || e.message)) || 'Could not add your free base. Please try again.'); } catch (x) {}
    });
    function fin() { busy = false; setBusy(false); refresh(); }
  }

  /* ---------- UI building blocks ---------- */
  function optsHtml() {
    return ''
      + opt('regular', 'Regular', '<span>Included</span>', '')
      + opt('chrome', 'Full Chrome', '', '<span class="bdfc-opt__pill bdfc-opt__pill--pop">Most popular</span>')
      + opt('holo', 'Holo Chrome', '', '<span class="bdfc-opt__pill bdfc-opt__pill--fx">Premium effect</span>');
    function opt(k, name, price, pill) {
      var img = k === 'chrome' ? C.chrome.img : k === 'holo' ? C.holo.img : '';
      var sw = '<span class="bdfc-sw bdfc-sw--' + k + '"' + (img ? ' style="background-image:url(' + esc(img) + ')"' : '') + '></span>';
      return '<button type="button" class="bdfc-opt" data-bdfc-pick="' + k + '">' + sw + pill
        + '<span class="bdfc-opt__tick">' + CHECK + '</span>'
        + '<span class="bdfc-opt__body"><span class="bdfc-opt__name">' + name + '</span>'
        + '<span class="bdfc-opt__price" data-bdfc-price="' + k + '">' + price + '</span></span></button>';
    }
  }
  function paintOpts(root, a) {
    if (!root) return;
    root.querySelectorAll('[data-bdfc-pick]').forEach(function (b) {
      var k = b.getAttribute('data-bdfc-pick');
      b.classList.toggle('is-selected', a.eligible && a.choice === k);
      b.classList.toggle('is-locked', !a.eligible && k !== 'regular');
      b.disabled = !a.eligible;
      if (k !== 'regular') {
        var val = (k === 'chrome' ? C.chrome.value : C.holo.value) * rate() * 100;
        var pr = b.querySelector('[data-bdfc-price]');
        if (pr) pr.innerHTML = '<s>' + esc(money(val, a.cur)) + '</s>' + (a.eligible ? '<em>FREE</em>' : 'FREE \u20ac' + C.threshold + '+');
      }
    });
  }
  function setBusy(on) {
    doc.querySelectorAll('.bdfc-opts').forEach(function (o) { o.classList.toggle('is-busy', !!on); });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-bdfc-pick]');
    if (b && !b.disabled) { e.preventDefault(); choose(b.getAttribute('data-bdfc-pick')); }
  });

  /* ---------- graphics kit page: live projection from YMQ selections ---------- */
  function hasYmq() { return !!(C.kit && doc.querySelector('.ymq-options-box[class*="Premium-Base-Image-Swatch"]')); }
  function ymqHidden(el) {
    for (var n = el, i = 0; n && n.nodeType === 1 && i < 12; n = n.parentElement, i++) {
      if (n.classList && (n.classList.contains('ymq-option-condition-hide') || n.classList.contains('ymq-option-condtion-disabled'))) return true;
    }
    return false;
  }
  function num(v) { var x = parseFloat(String(v || '').replace(',', '.').replace(/[^\d.]/g, '')); return isFinite(x) ? x : 0; }
  function kitCents() {
    var root = doc.querySelector('ymq-option') || doc.getElementById('MainContent') || doc.body;
    var form = doc.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var base = (idEl && C.kit.prices && C.kit.prices[idEl.value] != null) ? C.kit.prices[idEl.value] : C.kit.price;
    var opts = 0;
    root.querySelectorAll('input[ymq-option-price]').forEach(function (i) {
      if (i.disabled || ymqHidden(i)) return;
      var t = String(i.type || '').toLowerCase(), on = false;
      if (t === 'radio' || t === 'checkbox') on = i.checked;
      else if (t === 'text' || t === 'number' || t === 'email' || t === 'tel') on = !!String(i.value || '').trim();
      if (on) opts += num(i.getAttribute('ymq-option-price'));
    });
    root.querySelectorAll('select').forEach(function (sel) {
      if (sel.disabled || ymqHidden(sel)) return;
      Array.prototype.forEach.call(sel.selectedOptions || [], function (o) {
        if (!ymqHidden(o)) opts += num(o.getAttribute('ymq-option-price') || o.getAttribute('data-price'));
      });
    });
    var qEl = form && form.querySelector('[name="quantity"]');
    var q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    return (Number(base) || 0) * q + Math.round(opts * rate() * 100) * q;
  }
  function projected(a) {
    if (!hasYmq()) return null;
    var p = {}, k;
    for (k in a) p[k] = a[k];
    p.value = a.value + kitCents();
    p.unlocked = p.value >= p.target;
    p.toGo = Math.ceil(Math.max(0, p.target - p.value) / 100) * 100;
    p.pct = p.target > 0 ? Math.min(100, Math.round(p.value / p.target * 100)) : 100;
    return p;
  }

  /* ---------- running banner (all pages, top) ---------- */
  function insertBanner() {
    if (!isActive() || doc.querySelector('.bdfc-bar')) return;
    function item(t) { return '<span class="bdfc-bar__item">' + t + '</span><span class="bdfc-bar__dot"></span>'; }
    var group = '<div class="bdfc-bar__group">'
      + item('Free chrome weekend')
      + item('\u20ac' + C.threshold + '+ Graphic Kit Orders')
      + item('Free Full Chrome & Free Holo chrome Base')
      + item(esc(C.endsLabel))
      + '</div>';
    var bar = doc.createElement('div');
    bar.className = 'bdfc-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Free chrome weekend');
    bar.innerHTML = '<div class="bdfc-bar__track">' + group + group + group + group + '</div>';
    var hs = doc.getElementById('shopify-section-header');
    var hw = hs && hs.querySelector('.header__wrapper');
    /* same placement as the Stark Varg bar: in flow before the header, except on
       the homepage whose fixed header was tuned around a bar inside the wrapper */
    if (doc.documentElement.getAttribute('data-template') !== 'index' && hs && hs.parentNode) hs.parentNode.insertBefore(bar, hs);
    else if (hw) hw.insertBefore(bar, hw.firstChild);
    else if (hs) hs.insertBefore(bar, hs.firstChild);
    else if (doc.body) doc.body.insertBefore(bar, doc.body.firstChild);
  }

  /* ---------- floating bubble ---------- */
  var bubble = null;
  function ensureBubble() {
    if (bubble || !doc.body) return bubble;
    bubble = doc.createElement('button');
    bubble.type = 'button';
    bubble.id = 'bd-fc-bubble';
    bubble.setAttribute('data-bdfc-hidden', '');
    bubble.innerHTML =
      '<svg viewBox="0 0 100 100" aria-hidden="true"><defs>'
      + '<linearGradient id="bdfc-grad-chrome" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#6b7079"/><stop offset=".35" stop-color="#d9dce1"/><stop offset=".55" stop-color="#8a8f97"/><stop offset="1" stop-color="#1d2230"/></linearGradient>'
      + '<linearGradient id="bdfc-grad-holo" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#7b8cff"/><stop offset=".3" stop-color="#ff7fd8"/><stop offset=".55" stop-color="#3fe0b8"/><stop offset=".8" stop-color="#ffcc4d"/><stop offset="1" stop-color="#9b7bff"/></linearGradient>'
      + '</defs><circle class="bdfc-ring-track" cx="50" cy="50" r="46"/><circle class="bdfc-ring-fill" cx="50" cy="50" r="46" pathLength="100"/></svg>'
      + '<span class="bdfc-check">' + CHECK + '</span>'
      + '<span class="bdfc-in"><span class="bdfc-kicker"></span><span class="bdfc-main"></span><span class="bdfc-sub"></span></span>';
    bubble.addEventListener('click', function () { openModal(); });
    doc.body.appendChild(bubble);
    return bubble;
  }
  function paintBubble(a) {
    var b = ensureBubble();
    if (!b) return;
    if (!a.active) { b.setAttribute('data-bdfc-hidden', ''); return; }
    b.removeAttribute('data-bdfc-hidden');
    var k, m, s, word = false;
    var pr = projected(a);
    if (pr) {
      /* graphics kit page: cart + this kit with the YMQ options picked right now */
      a = pr;
      k = 'With this kit';
      if (!a.unlocked) { m = money(a.toGo, a.cur); s = 'to free chrome'; }
      else { m = 'Free'; s = 'chrome unlocked'; word = true; }
    }
    else if (!a.unlocked) { k = 'Free chrome'; m = money(a.toGo, a.cur); s = 'to go'; }
    else if (!a.kits) { k = 'Chrome'; m = 'Free'; s = 'add a kit'; word = true; }
    else if (a.choice === 'chrome') { k = 'Free base'; m = 'Chrome'; s = 'added'; word = true; }
    else if (a.choice === 'holo') { k = 'Free base'; m = 'Holo'; s = 'added'; word = true; }
    else { k = 'Unlocked'; m = 'Free'; s = 'pick chrome'; word = true; }
    b.querySelector('.bdfc-kicker').textContent = k;
    var me = b.querySelector('.bdfc-main');
    me.textContent = m;
    me.classList.toggle('is-word', word);
    b.querySelector('.bdfc-sub').textContent = s;
    b.querySelector('.bdfc-ring-fill').style.strokeDashoffset = String(100 - a.pct);
    b.classList.toggle('is-unlocked', a.unlocked);
    b.classList.toggle('is-pulse', !pr && a.eligible && !a.choice);
    b.setAttribute('aria-label', a.unlocked ? 'Free chrome base unlocked' : 'Free chrome base: ' + money(a.toGo, a.cur) + ' to go');
  }

  /* ---------- cart drawer panel ---------- */
  var panel = null;
  function ensurePanel() {
    if (panel && panel.isConnected) return panel;
    var root = doc.getElementById('bd-cart-root');
    var anchor = root && root.querySelector('[data-bd-rewards]');
    if (!anchor) return null;
    panel = doc.createElement('div');
    panel.className = 'bdfc-panel';
    panel.setAttribute('data-bdfc-hidden', '');
    panel.innerHTML =
      '<div class="bdfc-panel__head"><span class="bdfc-tag">Free chrome weekend</span><span class="bdfc-ends">' + esc(C.endsLabel) + '</span></div>'
      + '<p class="bdfc-panel__msg" data-bdfc-msg></p>'
      + '<div class="bdfc-track" data-bdfc-track><div class="bdfc-fill" data-bdfc-fill></div></div>'
      + '<div class="bdfc-opts" data-bdfc-opts>' + optsHtml() + '</div>'
      + '<p class="bdfc-warn" data-bdfc-warn hidden></p>';
    anchor.parentNode.insertBefore(panel, anchor.nextSibling);
    return panel;
  }
  function message(a) {
    var worth = money(C.holo.value * rate() * 100, a.cur);
    if (!a.unlocked) return 'Spend <strong>' + esc(money(a.toGo, a.cur)) + '</strong> more to get a <strong>free chrome base</strong> on your graphics kit (worth up to ' + esc(worth) + ').';
    if (!a.kits) return '<strong>Free chrome unlocked.</strong> Add any graphics kit and pick your base here.';
    if (a.choice === 'chrome') return '<strong>Full Chrome base added free.</strong> Switch anytime below.';
    if (a.choice === 'holo') return '<strong>Holographic Chrome base added free.</strong> Switch anytime below.';
    return '<strong>Free chrome unlocked.</strong> Pick your base below, it is on us.';
  }
  function paintPanel(a) {
    var p = ensurePanel();
    if (!p) return;
    if (!a.active || a.count <= 0) { p.setAttribute('data-bdfc-hidden', ''); return; }
    p.removeAttribute('data-bdfc-hidden');
    p.querySelector('[data-bdfc-msg]').innerHTML = message(a);
    p.querySelector('[data-bdfc-fill]').style.width = a.pct + '%';
    p.querySelector('[data-bdfc-track]').classList.toggle('is-done', a.unlocked);
    var opts = p.querySelector('[data-bdfc-opts]');
    if (a.eligible) { opts.removeAttribute('data-bdfc-hidden'); paintOpts(opts, a); }
    else opts.setAttribute('data-bdfc-hidden', '');
    var w = p.querySelector('[data-bdfc-warn]');
    if (a.eligible && a.paid) {
      w.hidden = false;
      w.textContent = 'Your kit already has ' + a.paid + ' as a paid option. Chrome is free this weekend: add the kit with Regular base and pick your chrome here instead.';
    } else w.hidden = true;
  }
  /* Free lines in the drawer: no qty stepper, crossed-out value + FREE. */
  function decorateLines(a) {
    var root = doc.getElementById('bd-cart-root');
    if (!root) return;
    [[a.chrome, C.chrome], [a.holo, C.holo]].forEach(function (pair) {
      var line = pair[0];
      if (!line) return;
      var el = root.querySelector('.bd-cart-item[data-bd-key="' + String(line.key).replace(/["\\]/g, '\\$&') + '"]');
      if (!el || el.classList.contains('bd-fc-line')) return;
      el.classList.add('bd-fc-line');
      var pr = el.querySelector('.bd-cart-item__price');
      if (pr) pr.innerHTML = '<s>' + esc(money(pair[1].value * rate() * 100 * line.quantity, a.cur)) + '</s> <b>FREE</b>';
      var bottom = el.querySelector('.bd-cart-item__bottom');
      if (bottom && !bottom.querySelector('.bdfc-line-note')) {
        var n = doc.createElement('span');
        n.className = 'bdfc-line-note';
        n.textContent = 'With your kit';
        bottom.insertBefore(n, bottom.firstChild);
      }
    });
  }

  /* ---------- popup ---------- */
  var modal = null;
  function ensureModal() {
    if (modal) return modal;
    modal = doc.createElement('div');
    modal.id = 'bd-fc-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="bdfc-scrim" data-bdfc-close></div>'
      + '<div class="bdfc-card" role="dialog" aria-modal="true" aria-labelledby="bdfc-title">'
      + '<button type="button" class="bdfc-x" data-bdfc-close aria-label="Close">&times;</button>'
      + '<span class="bdfc-tag">Weekend deal \u00b7 ' + esc(C.endsLabel) + '</span>'
      + '<h2 class="bdfc-title" id="bdfc-title">Free chrome base</h2>'
      + '<p class="bdfc-lead" data-bdfc-lead></p>'
      + '<div class="bdfc-track" data-bdfc-track><div class="bdfc-fill" data-bdfc-fill></div></div>'
      + '<div class="bdfc-nums"><span data-bdfc-have></span><span data-bdfc-goal></span></div>'
      + '<div class="bdfc-opts">' + optsHtml() + '</div>'
      + '<button type="button" class="bdfc-cta" data-bdfc-close data-bdfc-cta>Done</button>'
      + '<p class="bdfc-fine">One free base per order with a graphics kit, orders \u20ac' + C.threshold + '+. Keep Regular selected on the kit itself, your free base is added as its own line.</p>'
      + '</div>';
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bdfc-close]')) closeModal();
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });
    doc.body.appendChild(modal);
    return modal;
  }
  function paintModal(a) {
    if (!modal || modal.hidden) return;
    var lead;
    if (!a.unlocked) lead = 'Spend <strong>' + esc(money(a.toGo, a.cur)) + '</strong> more and upgrade your graphics kit to Full Chrome or Holographic Chrome, <strong>free</strong>.';
    else if (!a.kits) lead = '<strong>Unlocked.</strong> Add any graphics kit and pick your chrome base, free.';
    else lead = '<strong>Unlocked.</strong> Pick the base for your kit. It is on us.';
    modal.querySelector('[data-bdfc-lead]').innerHTML = lead;
    modal.querySelector('[data-bdfc-fill]').style.width = a.pct + '%';
    modal.querySelector('[data-bdfc-track]').classList.toggle('is-done', a.unlocked);
    modal.querySelector('[data-bdfc-have]').textContent = money(Math.min(a.value, a.target), a.cur);
    modal.querySelector('[data-bdfc-goal]').textContent = money(a.target, a.cur);
    modal.querySelector('[data-bdfc-cta]').textContent = a.eligible ? (a.choice ? 'Done' : 'Maybe later') : 'Keep shopping';
    paintOpts(modal, a);
  }
  function openModal() {
    if (!A || !A.active) return;
    ensureModal();
    modal.hidden = false;
    doc.documentElement.classList.add('bdfc-modal-open');
    paintModal(A);
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    doc.documentElement.classList.remove('bdfc-modal-open');
  }

  /* ---------- kit page note above Premium Base ---------- */
  function paintPdpNote() {
    if (doc.documentElement.getAttribute('data-template') !== 'product') return;
    var box = doc.querySelector('.ymq-options-box[class*="Premium-Base-Image-Swatch"]');
    if (!box || box.querySelector('.bdfc-pdp-note')) return;
    var first = box.querySelector('.ymq-option-value-item');
    var row = first ? first.parentElement : null;
    var n = doc.createElement('div');
    n.className = 'bdfc-pdp-note';
    n.innerHTML = '<span class="bdfc-sw bdfc-sw--holo"></span><span><b>Chrome base free this weekend</b> on orders \u20ac' + C.threshold
      + '+. Keep Regular here and pick Full Chrome or Holo Chrome for free in your cart.</span>';
    if (row && row.parentNode) row.parentNode.insertBefore(n, row); else box.appendChild(n);
  }
  function watchPdp() {
    if (doc.documentElement.getAttribute('data-template') !== 'product' || !isActive()) return;
    paintPdpNote();
    if (!('MutationObserver' in window)) return;
    var t, root = doc.getElementById('MainContent') || doc.body;
    /* throttle, not debounce: the page mutates constantly (timers, popups), so a debounce never fires */
    function tick() { if (t) return; t = setTimeout(function () { t = 0; paintPdpNote(); if (A && C.kit) paintBubble(A); }, 150); }
    new MutationObserver(tick).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked', 'selected'] });
    if (C.kit) {
      ['change', 'input', 'click'].forEach(function (ev) {
        doc.addEventListener(ev, function (e) {
          if (e.target && e.target.closest && e.target.closest('ymq-option, .ymq-options-box, form[action*="/cart/add"]')) { tick(); setTimeout(tick, 350); }
        }, true);
      });
    }
  }

  /* ---------- main ---------- */
  function paint(a) {
    doc.documentElement.classList.toggle('bdfc-on', !!a.active);
    paintBubble(a);
    paintPanel(a);
    decorateLines(a);
    paintModal(a);
  }
  function handle(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    var a = analyze(cart);
    A = a;
    paint(a);
    sync(a);
    if (a.eligible && !a.choice && !ss(K_PROMPTED) && !busy) {
      ss(K_PROMPTED, '1');
      setTimeout(openModal, 450);
    }
    if (!a.unlocked && ss(K_PROMPTED)) ss(K_PROMPTED, null); /* dropped below: prompt again on the next unlock */
  }

  doc.addEventListener('bd-cart:updated', function (e) {
    gotEvent = true;
    handle(e && e.detail && e.detail.cart);
  });

  if (isActive()) { doc.documentElement.classList.add('bdfc-on'); insertBanner(); }
  function boot() {
    insertBanner();
    watchPdp();
    /* Fallback if the drawer never broadcasts (drawer removed / failed). */
    setTimeout(function () {
      if (gotEvent) return;
      if (window.BDCart && BDCart.state) { handle(BDCart.state); return; }
      refresh();
    }, 2500);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
